// Backend URL configuration
// Auto-detect based on environment
const isProduction = typeof window !== 'undefined' && window.location.hostname !== 'localhost' && !window.location.hostname.startsWith('127.');
export const BACKEND_URL = isProduction 
  ? 'https://hara-xy-worker.hara-xy.workers.dev'
  : 'http://localhost:8788';
